import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { NgForm } from '@angular/forms';
import { Location } from '../../shared/location.model';
import { LocationService } from '../../shared/location.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css']
})
export class LocationComponent implements OnInit {

  locations: Location[];

  constructor(private service: LocationService,
    private firestore: AngularFirestore,
    private toastr: ToastrService) { }

  ngOnInit() {
    this.resetForm();
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.resetForm();
    this.service.locationData = {
      id: null,
      name: '',
      status: '',

    }

  }
  onSubmit(form: NgForm) {

    let data = Object.assign({}, form.value)
    delete data.id;
    if (form.value.id == null)
      this.firestore.collection('location').add(data);
    else
      this.firestore.doc('location/' + form.value.id).update(data);
  
    this.resetForm(form);
    this.toastr.success('Submitted Successfully', 'Location');
  }

}
